import React from "react";
import { LogOut } from "react-feather";

export function ButtonPrimary(props) {
  return (
    <button className="buttonPrimary" {...props}>
      {props.text}
    </button>
  );
}

export function ButtonSecondary(props) {
  return (
    <button className="buttonSecondary" {...props}>
      {props.text}
    </button>
  );
}

export function ButtonLogout(props) {
  return (
    <div className="buttonLogout" {...props}>
      <LogOut /> Logout
    </div>
  );
}
